// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const waterTrough = defineModel({
  id: "water-trough",
  batchId: "future",
  name: "Water trough",
  tags: ["scenery","water","trough","low-poly","age-of-mcp","future"],
  summary: "A trough watering animals at work or rest.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.3), color: "#8a6840", position: [0, 0.16, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.14, 0.05), color: "#6e4f2e", position: [0, 0.24, -0.13] },
      { geometry: new THREE.BoxGeometry(0.7, 0.14, 0.05), color: "#6e4f2e", position: [0, 0.24, 0.13] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.3), color: "#6e4f2e", position: [-0.34, 0.24, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.14, 0.3), color: "#6e4f2e", position: [0.34, 0.24, 0] },
      { geometry: new THREE.BoxGeometry(0.64, 0.03, 0.22), color: "#3b6b86", position: [0, 0.26, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.13, 0.05), color: "#563d22", position: [-0.3, 0.065, -0.1] },
      { geometry: new THREE.BoxGeometry(0.05, 0.13, 0.05), color: "#563d22", position: [0.3, 0.065, -0.1] },
      { geometry: new THREE.BoxGeometry(0.05, 0.13, 0.05), color: "#563d22", position: [-0.3, 0.065, 0.1] },
      { geometry: new THREE.BoxGeometry(0.05, 0.13, 0.05), color: "#563d22", position: [0.3, 0.065, 0.1] },
    ],
  animations: [],
});
